import { formatarDataHora } from "../../../shared/lib/date";
import { ROLES, isSuperAdmin } from "../../auth/lib/roles";

// Espelha domain.User.CheckCanCreateAccount: admin comum só cadastra médicos; contas de
// administrador só um superadmin cria. O backend continua sendo quem decide (403).
export function creatableRoles(viewer) {
  return isSuperAdmin(viewer) ? [ROLES.user, ROLES.admin, ROLES.superadmin] : [ROLES.user];
}

const TITLES = new Set(["dr", "dr.", "dra", "dra."]);

// "Dra. Ana Souza" → "Dra. Ana": o título fica junto do primeiro nome.
function greetingName(fullName) {
  const [first, second] = fullName.trim().split(/\s+/);
  return TITLES.has(first.toLowerCase()) && second ? `${first} ${second}` : first;
}

// Texto pronto para o admin colar no WhatsApp junto do link de definição de senha.
export function inviteMessage({ fullName, email, link, expiresAt }) {
  return (
    `Olá, ${greetingName(fullName)}! Criei sua conta no MedStation para você organizar seus plantões e recebimentos.\n\n` +
    `Para escolher sua senha, acesse: ${link}\n\n` +
    `O link vale até ${formatarDataHora(expiresAt)} e só pode ser usado uma vez. ` +
    `Depois é só entrar com o e-mail ${email}.`
  );
}
